<template>
  <div class="container">
    <!-- 操作区 -->
    <div class="btns">
      <q-btn
        unelevated
        rounded
        text-color="white"
        style="background: #3f89bd"
        @click="createGroupDialog()"
      >
        <q-icon name="fas fa-plus-circle" size="12px" class="q-mr-sm" />
        <span>新建小组</span>
      </q-btn>
      <!--
      | 在 updateAllGroupState() 中
      | 调用了 updateLittleGroupStateFun(),
      | 所以为了兼容在"全部出发"按钮的函数中传入参数为 "归来"
      | 在"全部归来"按钮的函数中传入参数为 "出发"。
      | 投机取巧。
      -->
      <q-btn
        unelevated
        rounded
        color="primary"
        @click="updateAllGroupState('归来')"
      >
        <q-icon name="fas fa-sign-out-alt" size="12px" class="q-mr-sm"></q-icon>
        <span>全部出发</span>
      </q-btn>

      <q-btn
        unelevated
        rounded
        text-color="white"
        style="background: #124561"
        @click="updateAllGroupState('出发')"
      >
        <q-icon
          name="fas fa-arrow-circle-left"
          size="12px"
          class="q-mr-sm"
        ></q-icon>
        <span>全部归来</span>
      </q-btn>
    </div>

    <!-- 成员关联小组列表 -->
    <div>
      <q-scroll-area style="height: 550px">
        <div v-if="little_group_list.length == 0">
          <empty
            text="没有小组"
            style="margin-top: 50%; transform: translateY(-50%)"
          ></empty>
        </div>
        <div v-else>
          <div
            class="little-group"
            v-for="(little_group, index) in little_group_list"
            :key="little_group.id"
          >
            <!-- 关联小组用户头像 -->
            <div style="height: 100px; display: flex">
              <div style="width: 80%; margin: auto 0">
                <q-avatar
                  v-for="user in little_group.users"
                  :key="user.id"
                  class="tlqn-agmli-avatar_display"
                  size="55px"
                  style="margin-left: 20px"
                >
                  {{ user.nickname.substr(0, 1) }}
                </q-avatar>
              </div>

              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: space-around;
                "
              >
                <q-btn
                  style="background: #3f89bd; color: white"
                  @click="modifyGroupDialog()"
                  >修改
                  <q-menu>
                    <div style="width: 400px">
                      <q-card-section class="row items-center q-pb-none">
                        <div class="text-h6">修改小组成员</div>
                        <q-space />
                        <q-btn
                          icon="fas fa-times"
                          flat
                          round
                          dense
                          v-close-popup
                        />
                      </q-card-section>

                      <q-card-section class="q-pa-md">
                        <div v-for="member in members_list" :key="member.id">
                          <q-checkbox
                            v-if="
                              checkbox_member[`${member.id}`].is_grouping &&
                                little_group.users.some(
                                  (user) => user.id === member.id
                                )
                            "
                            v-model="checkbox_member[`${member.id}`].available"
                          >
                            <p style="margin: auto 0">
                              {{ member.nickname }}
                              <q-badge color="positive"
                                >已经分配到当前组</q-badge
                              >
                            </p>
                          </q-checkbox>

                          <q-checkbox
                            v-else-if="
                              checkbox_member[`${member.id}`].is_grouping ===
                                false
                            "
                            v-model="checkbox_member[`${member.id}`].available"
                            ><p style="margin: auto 0">
                              {{ member.nickname }}
                              <q-badge color="grey">未分配</q-badge>
                            </p></q-checkbox
                          >

                          <q-checkbox
                            v-else
                            disable
                            v-model="checkbox_member[`${member.id}`].current"
                            ><p style="margin: auto 0">
                              {{ member.nickname }}
                              <q-badge color="negative"
                                >已经在其他小组分配</q-badge
                              >
                            </p></q-checkbox
                          >
                        </div>
                      </q-card-section>

                      <q-card-section>
                        <q-btn
                          color="primary"
                          label="确定"
                          text-color="white"
                          v-close-popup
                          @click="modifyLittleGroupMember(index)"
                        ></q-btn>
                      </q-card-section>
                    </div>
                  </q-menu>
                </q-btn>
                <q-btn
                  text-color="white"
                  :style="{
                    background:
                      little_group.state === '归来' ? '#DF602F' : '#124561',
                  }"
                  @click="
                    updateLittleGroupStateFun(
                      little_group.id,
                      little_group.state
                    )
                  "
                  >{{ little_group.state === "归来" ? "出发" : "归来" }}</q-btn
                >
              </div>
            </div>

            <!-- 关联小组状态 -->
            <div
              class="status text-subtitle1"
              :style="{
                background: bgColor(little_group.state),
                height: '50px',
              }"
            >
              已经{{ little_group.state }}
            </div>
          </div>
        </div>
      </q-scroll-area>
    </div>

    <!-- 创建小组弹窗 -->
    <q-dialog v-model="create_little_group_dialog">
      <q-card style="width: 400px">
        <p style="font-size: 18px; font-weight: 600; margin: 15px 20px 0">
          创建小组
        </p>
        <q-card-section
          v-if="isAllMemberGrouped()"
          style="height: 20vh; overflow-y: auto"
        >
          <div
            style="
              height: 60%;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 20px;
              font-weight: 600;
            "
          >
            所有成员都已经创建小组
          </div>
        </q-card-section>
        <q-card-section v-else style="height: 40vh; overflow-y: auto">
          <p style="color: red; margin: 0 5px">仅显示还未分配小组的成员</p>
          <div
            v-for="member in members_list"
            :key="member.id"
            style="
              font-size: 18px;
              margin: 10px;
              box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
            "
          >
            <q-checkbox
              v-if="checkbox_member[`${member.id}`].is_grouping === false"
              v-model="checkbox_member[`${member.id}`].available"
            >
              <p style="margin: auto 0">{{ member.nickname }}</p>
            </q-checkbox>
          </div>
        </q-card-section>

        <q-card-actions align="right" style="margin-bottom: 20px">
          <q-btn flat label="取消" color="primary" v-close-popup />
          <q-btn
            flat
            label="确定"
            style="background: #df602f; color: #ffffff; margin-right: 20px"
            v-close-popup
            @click="submitCreateLittleGroup()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import LeaderCommonStatus from "../mixins/status.mixin";
import { createLittleGroup } from "../../../api/endpoints/little-group/createLittleGroup";
import { updateLittleGroupState } from "../../../api/endpoints/little-group/updateLittleGroupState";
import { updateLittleGroupUser } from "../../../api/endpoints/little-group/updateLittleGroupUser";
import { getLittleGroupDetailLeader } from "../../../api/endpoints/little-group/getLittleGroupDetailLeader";

export default {
  mixins: [LeaderCommonStatus],
  components: {
    Empty: () => import("../../../components/Empty.vue"),
  },
  data() {
    return {
      little_group_list: [], // 已经分好的小组列表
      members_list: [], // 当前小组的成员列表
      create_little_group_dialog: false, // 控制创建小组的弹窗
      checkbox_member: {}, // 用于创建小组时绑定复选框
      alread_grouping_members: [], // 已经组成小队的成员
      request_flag: undefined, // 标价位用于页面刷新
      current_group_id: "", // 小组 id
      rebuild_checkbox_obj: undefined,
    };
  },

  mounted() {},

  computed: {
    members() {
      return this.getCurrentGroupLeaderStatus("users");
    },

    group_id() {
      return this.getCurrentGroupLeaderStatus("current_group_id");
    },
  },

  watch: {
    little_group_list: {
      handler(littleGroupList) {
        let alreadGroupingMenbers = [];
        for (let item of littleGroupList) {
          item.users.forEach((value) => {
            alreadGroupingMenbers.push(value.nickname);
          });
        }
        this.alread_grouping_members = alreadGroupingMenbers;
      },
    },

    members: {
      handler(members) {
        this.members_list = members;
        this.buildCheckboxObject(members);
      },
    },

    group_id: {
      immediate: true,
      handler(id) {
        this.current_group_id = id;
        this.letterGroupList(id);
      },
    },

    request_flag: {
      handler() {
        this.letterGroupList(this.current_group_id);
      },
    },

    rebuild_checkbox_obj: {
      handler() {
        this.buildCheckboxObject(this.members_list);
      },
    },
  },

  methods: {
    /**
     * 已经创建的成员之间的小组
     */
    async letterGroupList(id) {
      try {
        const response = await getLittleGroupDetailLeader(id);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.little_group_list = response.filter(
            (little_group) => little_group.users.length !== 0
          );
          this.rebuild_checkbox_obj = Math.random();
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({ type: "danger", name: "获取错误" });
      }
    },

    /**
     * 创建小组
     */
    async createLittleGroupFun(id, users) {
      try {
        const response = await createLittleGroup(id, users);
        if (response.status || response.error) {
          console.log("create group", response);
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.request_flag = Math.random();
          this.$q.notify({
            type: "positive",
            message: "创建完成",
          });
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({ type: "danger", message: "获取错误" });
      }
    },

    /**
     * 更新小组状态
     */
    async updateLittleGroupStateFun(little_group_id, state) {
      try {
        const response = await updateLittleGroupState(little_group_id, state);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.request_flag = Math.random();
          this.$q.notify({
            type: "positive",
            message: "更新小组状态完成",
          });
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({ type: "danger", message: "更新小组状态失败" });
      }
    },

    /**
     * 绑定提交按钮
     */
    submitCreateLittleGroup() {
      let littleGroupMembersId = [];
      for (let item in this.checkbox_member) {
        if (
          this.checkbox_member[item].available === true &&
          this.checkbox_member[item].id === null
        ) {
          littleGroupMembersId.push(item);
        }
      }

      if (littleGroupMembersId.length != 0) {
        console.log(littleGroupMembersId);
        this.createLittleGroupFun(this.current_group_id, littleGroupMembersId);
      } else {
        this.$q.notify("未选择任何成员");
      }
    },

    /**
     * 判断所有成员是否都已经分组
     */
    isAllMemberGrouped() {
      for (let item in this.checkbox_member) {
        if (this.checkbox_member[item].is_grouping === false) return false;
      }
      return true;
    },

    /**
     * 控制用于创建小组弹窗
     */
    createGroupDialog() {
      this.create_little_group_dialog = !this.create_little_group_dialog;
    },

    /**
     * 控制用于修改小组成员的弹窗
     */
    modifyGroupDialog() {
      this.modify_little_group_dialog = !this.modify_little_group_dialog;
    },

    /**
     * 修改小组中的用户
     */
    async modifyLittleGroupMember(index) {
      let append = []; // 需要添加到小组中的成员
      let remove = []; // 需要从小组中删除的成员
      let currentLittleGroup = this.little_group_list[index];
      let currentLittleGroupId = currentLittleGroup.id;
      let currentMemberIdList = currentLittleGroup.users.map((item) => item.id);

      currentMemberIdList.forEach((id) => {
        if (
          this.checkbox_member &&
          this.checkbox_member[id] &&
          this.checkbox_member[id].available === false
        ) {
          remove.push(id); // 添加到待删除的列表中
        }
      });
      for (let key in this.checkbox_member) {
        if (
          this.checkbox_member &&
          this.checkbox_member[key] &&
          this.checkbox_member[key].available === true &&
          this.checkbox_member[key].id === null
        ) {
          append.push(key);
        }
      }

      try {
        const response = await updateLittleGroupUser(
          currentLittleGroupId,
          append,
          remove
        );
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.request_flag = Math.random();
          this.$q.notify({
            type: "positive",
            message: "修改小组成员完成",
          });
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({ type: "danger", message: "更新小组成员失败" });
      }
    },

    updateAllGroupState(state) {
      this.little_group_list.forEach((group) => {
        this.updateLittleGroupStateFun(group.id, state);
        this.request_flag = Math.random();
      });
    },

    bgColor(state) {
      return state == "归来" ? "#124561" : "#df602f";
    },

    /**
     * 用于构造复选框绑定对象
     */
    buildCheckboxObject(member_list) {
      member_list.forEach((value) => {
        let key = value.id;
        if (this.alread_grouping_members.includes(value.nickname)) {
          this.$set(this.checkbox_member, key, {
            id: value.id,
            is_grouping: true, // 已经组成小组
            available: true,
            cureent: null,
          });
        } else {
          this.$set(this.checkbox_member, key, {
            id: null,
            is_grouping: false, // 还没有组成小组
            available: false,
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/quasar";
.container {
  width: 80%;
  display: flex;
  flex-direction: column;
  margin-left: 8%;
}

.btns {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.little-group {
  width: 100%;
  height: 150px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #ccc;
  margin-bottom: 20px;
  .status {
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
}

.tlqn-agmli-avatar_display {
  background-color: rgba($primary, 0.2);
  color: $primary;
  font-weight: bold;
}

@media screen and (max-width: 800px) {
  .btns {
    width: 85%;
  }
}
</style>
